export function areDigits(value) {
  return /^($|\d+$)/.test(value);
}
